var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8C1 4.13406 4.13406 1 8 1C11.8659 1 15 4.13406 15 8C15 11.8659 11.8659 15 8 15C4.13406 15 1 11.8659 1 8ZM7.3125 5.125C7.3125 5.26313 7.42438 5.375 7.5625 5.375H8.4375C8.57563 5.375 8.6875 5.26313 8.6875 5.125V4.25C8.6875 4.11188 8.57563 4 8.4375 4H7.5625C7.42438 4 7.3125 4.11188 7.3125 4.25V5.125ZM6.95313 7.75H7.51563V11.75C7.51563 11.8881 7.6275 12 7.76563 12H8.64063C8.77875 12 8.89063 11.8881 8.89063 11.75V6.625C8.89063 6.48688 8.77875 6.375 8.64063 6.375H6.95313C6.815 6.375 6.70313 6.48688 6.70313 6.625V7.5C6.70313 7.63813 6.815 7.75 6.95313 7.75Z",
    fill: "#F5455D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/tip.39b48b9b8b98a4e42e45818a65fe2404.svg";
export { ForwardRef as ReactComponent };